export default {"src":"/_next/static/media/tab.f43c6126.svg","height":36,"width":61,"blurWidth":0,"blurHeight":0};